import { render } from "./BaseVersioningDialog.vue?vue&type=template&id=b78bd34a&scoped=true"
import script from "./BaseVersioningDialog.vue?vue&type=script&lang=js"
export * from "./BaseVersioningDialog.vue?vue&type=script&lang=js"

import "./BaseVersioningDialog.vue?vue&type=style&index=0&id=b78bd34a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b78bd34a"]])

export default __exports__